export const ACCESSIBILITY_FILTER_VISIBILITY = {
    NOT_SHOW_ACCESSIBLE_FILTERS: 'notShowAccessibleFilters',
    SHOW_ACCESSIBILITY_FILTER_BOTH: 'showAccessibilityFilterBoth',
    SHOW_ACCESSIBILITY_FILTER_PANEL_ONLY: 'showAccessibilityFilterPanelOnly'
};

export const ACCESSIBILITY_FILTER_UNCHECKED = {
    SHOW_ACCESSIBLE_BOTH: 'showAccessibleBoth',
    SHOW_REGULAR_ONLY: 'showRegularOnly'
};

export const ACCESSIBILITY_FILTER_PRESELECTION = {
    ACCESSIBLE_CHECKED: true,
    ACCESSIBLE_NOT_CHECKED: false
};



// WEBPACK FOOTER //
// ./src/constants/AccessibilityTypes.js